<template>
  <div class="main-page legalaid-report">
    <Menus
      title="法援援助"
      :border="true"
    >
      <a
        slot="left-link"
        href="javascript:void(0)"
        @click="goback"
      >
      </a>
    </Menus>
    <div id="qrcode" />
    <div class="container-flex">
      <div class="content-step">
        <Step
          :steplist="steplist"
          :type="step"
        />

        <div class="steps">
          <div
            id="div_report"
            class="report-container"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Step from '@/components/FayuanStep'
export default {
  components: {
    Menus,
    Step
  },
  data () {
    return {
      steplist: ['援助预申请', '填写申请信息','上传相关文件', '申请成功'],
      step: 1,
      report: '',
      appback: false
    }
  },
  async mounted () {
    if (this.$route.fullPath) {
      const url = 'https://yn.12348.laway.cn/api/get' + this.$route.fullPath
      $.get(url, results => {// eslint-disable-line
        if (results.status === 1) {
          $("#div_report").html(results.result.content); // eslint-disable-line
          this.report = results.result.content
          this.$nextTick(() => {
            if (window.step) {
              this.step = parseInt(window.step)
            }
            if (document.getElementById('rotue_jump')) {
              document.getElementById('rotue_jump').onclick = e => {
                const href = e.target.dataset.href + '?step=' + this.step
                console.log(href, 'href')
                this.$router.push(href)
              }
            }
            if (document.getElementById('gohome')) {
              document.getElementById('gohome').onclick = e => {
                this.$router.push('/')
              }
            }
            if (window.appback) {
              this.appback = window.appback
            }
          })
        }
      })
    }
  },
  methods: {
    getDateTime () {
      return this.$moment().format('YYYY-MM-DD HH:mm:ss')
    },
    goback () {
      if (this.step === 3) {
        this.$router.push('/')
      } else {
        // this.$router.back(-1)
        this.$router.goBack()
        setTimeout(() => {
          this.$scrollTo(0)
        }, 0)
      }
      this.step -= 1
    }
  }
}
</script>
<style lang="stylus" >
.legalaid-report
  .content-step
    padding 0.4rem 0 0.5rem 0
  .steps
    margin 0.3rem auto 0 auto
    color #fff
    .report-legalaid-upload
      padding 0.3rem
      font-size 0.24rem
      text-align: center
    #div_report
      width 12rem
      margin 0 auto
      border-radius 0.3rem
      padding-top 0.5rem
      background-color rgba(255, 255, 255, 0.2)
      border solid 1px rgba(255, 255, 255, 0.2)
      box-shadow 0 0.1rem 0.25rem rgba(0, 0, 0, 0.05)
      .page__block_title
        text-align center
        font-size 0.4rem
        padding 0 0 0.64rem 0
        line-height 0.4rem
        letter-spacing 0px
      .page__block_content
        padding 0 1.2rem 0.3rem 0.94rem
        font-size 0.3rem
        line-height 2
        p:first-child
          margin 0.15rem 0
        h3
          font-size 0.3rem
          margin 0.15rem 0
      .uploadinfo
        padding 0 0.51rem
        text-align center
        .title
          text-align left
          font-size 0.4rem
          margin-bottom 0.1rem
        img
          width 4.9rem
          height 4.18rem
          margin-left 3.1rem
          object-fit cover
  .button, #rotue_jump
    display block
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    font-size 0.34rem
    color #fff
    border 0
    margin 0.8rem auto 0.7rem auto
    background-color #fc9d0b
    border-radius 0.1rem
    .userinfo
      border-radius 0.3rem
      border solid 1px rgba(255, 255, 255, 0.2)
</style>
